import { Group, LoadingOverlay, Stack } from '@mantine/core';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useFlowByPhaseTabStore } from '../../../../../store/strategy-store/strategy-store';
import {
  setFlowByPhaseMetric,
  setFlowByPhaseSelectedDate,
} from '../../../../../store/strategy-store/strategy-store.actions';
import { secondaryBase, skyDark } from '../../../../../styles/design-tokens';
import { Icon } from '../../../../../ui-library/icon/icon';
import { Select } from '../../../../../ui-library/select/select';
import { Text } from '../../../../../ui-library/typography/typography';
import { MainSectionControls } from '../../components/main-section-controls/main-section-controls';
import { hasArrayData } from '../../initiative-performance.helpers';
import { useChartData, useDateOptions, useFlowByPhaseData } from '../flow-by-phase-tab.hooks';
import { FlowByPhaseChart } from './flow-by-phase-chart/flow-by-phase-chart';

export const MainSection = () => {
  const metric = useFlowByPhaseTabStore((state) => state.metric);
  const selectedDate = useFlowByPhaseTabStore((state) => state.selectedDate);
  const selectedEpic = useFlowByPhaseTabStore((state) => state.selectedEpic || undefined);
  const chartRef = useRef<HTMLDivElement>(null!);
  const { chartData, currentDate } = useChartData();
  const dateOptions = useDateOptions();

  const { isLoading } = useFlowByPhaseData(selectedEpic);

  const { t } = useTranslation();

  const title = (
    <Group>
      <Text size="large" weight="bold">
        {t('strategy.initiative_performance.flow_by_phase')}
      </Text>
      {hasArrayData(dateOptions) && (
        <Select
          size="sm"
          options={dateOptions}
          value={selectedDate || ''}
          onChange={setFlowByPhaseSelectedDate}
          placeholder={t('common.placeholders.select_date')}
          style={{ width: 160 }}
          rightSection={<Icon name="calendar_month" size={16} color={skyDark} />}
          rightSectionPointerEvents="none"
        />
      )}
    </Group>
  );

  return (
    <Stack h="100%" style={{ overflow: 'hidden', position: 'relative' }}>
      <LoadingOverlay visible={isLoading} loaderProps={{ color: secondaryBase }} />
      <MainSectionControls
        title={title}
        chartRef={chartRef}
        metric={metric}
        setMetric={setFlowByPhaseMetric}
        disableControls={!currentDate || !hasArrayData(chartData)}
      />
      <FlowByPhaseChart ref={chartRef} />
    </Stack>
  );
};
